import { render } from "./TranslationMenu.vue?vue&type=template&id=c341cc88&scoped=true"
import script from "./TranslationMenu.vue?vue&type=script&lang=js"
export * from "./TranslationMenu.vue?vue&type=script&lang=js"

import "./TranslationMenu.vue?vue&type=style&index=0&id=c341cc88&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c341cc88"]])

export default __exports__